export default __webpack_public_path__ + "static/media/poster.42fb7836.jpg";